export default __webpack_public_path__ + "static/media/TXUI_SortRule_Overflow.256.7ebde0ec.png";